import ScheduleColumnManager from '../../schedules/ScheduleColumnManager';

export default class OptableColumnManager extends ScheduleColumnManager {
  constructor(session, counterparty, optedDataField, optedDataCaption) {
    super(session, counterparty);

    this.optedDataField = optedDataField;
    this.optedDataCaption = optedDataCaption;
  }

  addLeadingColumns(columns) {
    super.addLeadingColumns(columns);

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: true,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: false,
      allowResizing: false,
      dataType: 'boolean',
      caption: this.optedDataCaption,
      dataField: this.optedDataField,
      showEditorAlways: true,
      visible: true,
      width: 60
    });
  }

  addIntermediateColumns(columns) {
    super.addIntermediateColumns(columns);

    this.addColumn(columns, {
      alignment: 'left',
      allowEditing: false,
      allowFiltering: true,
      allowHiding: true,
      allowResizing: true,
      dataType: 'string',
      caption: 'Contract',
      dataField: 'contractCode',
      visible: false,
      width: 80
    });
  }

  addTrailingColumns(columns) {
    super.addTrailingColumns(columns);

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'Sum (Hours)',
      dataField: 'energySumH',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: false,
      width: 85
    });

    this.addColumn(columns, {
      alignment: 'center',
      allowEditing: false,
      allowFiltering: false,
      allowGrouping: false,
      allowHiding: true,
      allowResizing: true,
      caption: 'Sum (MWh)',
      dataField: 'energySumMWh',
      dataType: 'number',
      format: this.formatNumber.bind(this),
      visible: true,
      width: 85
    });
  }

  getColumnCssClass() {
    return 'pwx-alert-overlay-none pwx-flag-none pwx-state-normal pwx-highlight-none pwx-cell-standard';
  }
}